
import Seo from '../../components/Seo';
const DOTS = (
  <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
);

const CHK = (
  <svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
);

function Bar({ h, kind }) {
  const bg = kind === 'mt' ? '#469FD8' : kind === 'id' ? '#dfe3e9' : '#2DBDB8';
  return <i className={kind || ''} style={{flex: 1, borderRadius: '3px 3px 0 0', background: bg, height: h}}></i>;
}

export default function HourlyBreakdownPage() {
  
  return (
    <>
      <Seo title="Hourly Breakdown — Hour-by-Hour Work Activity Tracking | TeamGrid™" description="Break each workday into hourly blocks, each with its own activity log, score and summary. Find the hours your team is sharpest in, then protect them." />
      <header className="fh">
        <div className="fh-grid">
          <div className="fh-copy">
            <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Time Analytics <span className="arr">›</span></span>
            <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '26px', maxWidth: '760px'}}>The workday,<br /><span style={{color: '#a9aab3'}}>hour by hour</span></h1>
            <p style={{maxWidth: '620px', marginBottom: '26px', fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)'}}>Each day breaks into hourly segments with its own activity log, its own score and its own summary. Open any hour and see what actually happened.</p>
            <ul className="hero-checks">
              <li>{CHK}<span><b>Hour-by-hour view.</b> Exactly what happened in each hour of work.</span></li>
              <li>{CHK}<span><b>Activity breakdown.</b> Apps, websites and tasks per time block.</span></li>
              <li>{CHK}<span><b>Hourly scores.</b> A score for every hour, not just the day.</span></li>
            </ul>
            <div className="hero-cta-row">
              <a className="btn-primary" href="/register">See your hours free</a>
              <span className="hero-cta-note">7-day free trial.<br />No credit card.</span>
            </div>
          </div>
          <div className="fh-vis">
            <div className="frame">
              <div className="frame-h">{DOTS}SCORE BY HOUR — TODAY, 9AM TO 6PM</div>
              <div className="hbars" style={{display: 'flex', alignItems: 'flex-end', gap: '4px', height: '116px', padding: '18px 18px 14px'}}>
                <Bar h="62%" /><Bar h="74%" /><Bar h="85%" /><Bar h="68%" /><Bar h="46%" kind="mt" /><Bar h="40%" kind="id" /><Bar h="77%" /><Bar h="81%" /><Bar h="58%" kind="mt" />
              </div>
              <div className="applist" style={{padding: '4px 18px 12px', borderTop: '1px solid var(--line-soft)'}}>
                <span className="ap"><i style={{background: '#2DBDB8'}}></i>11:00 – 12:00<span className="bar"><b style={{width: '85%', background: '#2DBDB8'}}></b></span><span className="pc">85%</span></span>
                <span className="ap"><i style={{background: '#2DBDB8'}}></i>16:00 – 17:00<span className="bar"><b style={{width: '81%', background: '#2DBDB8'}}></b></span><span className="pc">81%</span></span>
                <span className="ap"><i style={{background: '#469FD8'}}></i>13:00 – 14:00<span className="bar"><b style={{width: '46%', background: '#469FD8'}}></b></span><span className="pc">46%</span></span>
                <span className="ap"><i style={{background: '#dfe3e9'}}></i>14:00 – 15:00<span className="bar"><b style={{width: '40%', background: '#dfe3e9'}}></b></span><span className="pc">40%</span></span>
              </div>
              <div style={{padding: '0 18px 16px', fontSize: '11px', fontWeight: '800', letterSpacing: '1.4px', color: 'var(--ink-faint)'}}>PEAK BLOCK 11:00 – 12:00 · 85% · 9 HOURS LOGGED</div>
            </div>
          </div>
        </div>
      </header>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <h2 className="sect-h2">Granular time<br /><span className="dim">intelligence</span></h2>
          <p className="sect-sub">No screenshots. No keystrokes. Just the <span className="def" title="Patterns, not people: we measure the shape of work — never its private content.">honest shape of each hour</span>.</p>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#2DBDB8'}}>HOUR-BY-HOUR VIEW</span>
              <h3>Find the hours your team is actually best in</h3>
              <p className="fd">Deep focus in teal, meetings in blue, idle in grey. One glance tells you where the peak sits and where the day leaks. Then move the standup off the peak.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Peak performance hours, named not guessed</li>
                <li><span className="sarr">→</span>Distraction blocks visible the same day</li>
                <li><span className="sarr">→</span>Schedules built around real energy, not habit</li>
              </ul>
            </div>
            <div className="frame">
              <div className="frame-h">{DOTS}HOURLY BREAKDOWN — MONDAY, NOV 24</div>
              <div className="hbars" style={{display: 'flex', alignItems: 'flex-end', gap: '4px', height: '150px', padding: '20px'}}>
                <Bar h="24%" /><Bar h="48%" /><Bar h="76%" /><Bar h="88%" /><Bar h="92%" /><Bar h="58%" kind="mt" /><Bar h="16%" kind="id" /><Bar h="42%" kind="mt" /><Bar h="70%" /><Bar h="85%" /><Bar h="62%" /><Bar h="34%" kind="mt" /><Bar h="54%" /><Bar h="12%" kind="id" />
              </div>
            </div>
          </div>

          <div className="frow rev">
            <div className="frame">
              <div className="frame-h">{DOTS}HOURLY TIMELINE — MONDAY, NOV 24</div>
              <div className="applist" style={{padding: '16px 18px'}}>
                <span className="ap">10:00 – 11:00<span className="bar"><b style={{width: '67%', background: '#34A851'}}></b></span><span className="pc">39m</span></span>
                <span className="ap">11:00 – 12:00<span className="bar"><b style={{width: '72%', background: '#34A851'}}></b></span><span className="pc">60m</span></span>
                <span className="ap">12:00 – 13:00<span className="bar"><b style={{width: '62%', background: '#34A851'}}></b></span><span className="pc">47m</span></span>
                <span className="ap">13:00 – 14:00<span className="bar"><b style={{width: '31%', background: '#6C59A6'}}></b></span><span className="pc">22m</span></span>
                <span className="ap">14:00 – 15:00<span className="bar"><b style={{width: '81%', background: '#34A851'}}></b></span><span className="pc">54m</span></span>
              </div>
            </div>
            <div className="fr-copy">
              <span className="fl" style={{color: '#469FD8'}}>ACTIVITY BREAKDOWN</span>
              <h3>Open an hour, see the apps behind it</h3>
              <p className="fd">Every block carries its own log: which apps, which sites, which tasks, and how long each one held attention. Green is productive time, purple is meeting time.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Apps, websites and tasks per time block</li>
                <li><span className="sarr">→</span>Written work summary attached to each hour</li>
                <li><span className="sarr">→</span>Nothing to fill in — the log builds itself</li>
              </ul>
            </div>
          </div>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#8B75D7'}}>HOURLY SCORES</span>
              <h3>A score per hour, and it explains itself</h3>
              <p className="fd">A daily average hides the story. Hourly scores show the 85% morning and the 40% afternoon separately, so the fix is obvious and specific.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Individual score for each hour of the day</li>
                <li><span className="sarr">→</span>Compared to that person&apos;s own baseline</li>
                <li><span className="sarr">→</span>Rolls up to day, week, team and company</li>
              </ul>
            </div>
            <div className="frame sumcard">
              <div className="sc-t">HOUR SUMMARY — 11:00 TO 12:00</div>
              <p style={{fontSize: '13.5px', lineHeight: '20px'}}>Full <b>60m</b> of tracked work at an <b>85%</b> score. 72% went to build tools, 28% to review and docs. No idle gaps. This is the strongest block of the day, three days running.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <div className="roi-cards" style={{marginTop: '0'}}>
            <div className="roi-card"><div className="rl">GRANULARITY</div><div className="rv">1 hour</div><p>Every day split into hourly blocks, each with a log and a score.</p></div>
            <div className="roi-card"><div className="rl">PEAK BLOCK</div><div className="rv">85%</div><p>The best hour in the day above. Find yours, then protect it.</p></div>
            <div className="roi-card"><div className="rl">TIMESHEETS</div><div className="rv">0</div><p>No manual entry. Hours are captured, not typed in later.</p></div>
            <div className="roi-card"><div className="rl">SCREENSHOTS</div><div className="rv">0</div><p>Ever. Patterns, not people — measurement with dignity.</p></div>
          </div>
        </div>
      </section>

      <div className="container"><p className="roi-note" style={{margin: '0 0 4px'}}>*Sample workspace data shown. Your numbers come from your own team.</p></div>
      <div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/monitoring">Monitoring →</a><a href="/features/project-tracking">Project Tracking →</a></div></div>

      <section className="sect" style={{padding: '8px 0 24px'}}>
        <div className="container">
          <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
          <div className="faq">
            <details><summary>How does an hourly breakdown help productivity?</summary><p>It shows how work time is distributed through the day, so teams can spot peak performance hours, identify distractions and reshape the schedule around when people are genuinely sharp.</p></details>
            <details><summary>Is manual timesheet entry required?</summary><p>No. Activity is captured automatically, which removes timesheet chasing and makes billable time more accurate at the same time.</p></details>
            <details><summary>Can I see utilization per person and per team?</summary><p>Yes. Hourly data rolls up to the individual and to the team, so efficiency gaps show at both levels instead of averaging away.</p></details>
          </div>
        </div>
      </section>

      <section className="final" style={{paddingTop: '48px'}}>
        <div className="container-wide">
          <div className="final-band" style={{paddingBottom: '88px'}}>
            <h2>Find your best hours<br />and protect them</h2>
            <a className="btn-white" href="/register">Get started FREE</a>
          </div>
        </div>
      </section>
    </>
  );
}
